<template>
  <div v-if="!isLoading && venueCampaign && activeVenue">
    <vs-breadcrumb class="mt-2">
      <li>
        <router-link to="/vp/venuecampaigns"> Venue Campaigns</router-link
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="active">Fill out campaign</li>
    </vs-breadcrumb>

    <vs-tabs position="left" class="tabs-shadow-none mt-2" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab icon-pack="feather" icon="icon-zap" :label="!isSmallerScreen ? 'General' : ''">
        <div class="lists-view-tab">
          <venue-campaign-general
            :venue-campaign="venueCampaign"
            v-on:onSubmit="onSubmit"
            v-on:onReset="onReset"
            :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')"
          />
        </div>
      </vs-tab>
      <vs-tab
        v-if="venueCampaign.hasEmail"
        icon-pack="feather"
        icon="icon-mail"
        :label="!isSmallerScreen ? 'Email' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-email
            :venue-campaign="venueCampaign"
            v-on:onSave="onClickSave"
            :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')"
          />
        </div>
      </vs-tab>
      <vs-tab
        v-if="venueCampaign.hasSms"
        icon-pack="feather"
        icon="icon-smartphone"
        :label="!isSmallerScreen ? 'Sms' : ''"
      >
        <div class="lists-view-tab">
          <venue-campaign-sms
            :venue-campaign="venueCampaign"
            v-on:onSave="onClickSave"
            :isEditable="isEditable && $AuthService.hasPermissionForActiveVenue('vp.vp.venuecampaigns.edit')"
          />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VenueCampaignGeneral from "./Components/VenueCampaignGeneral.vue";
import VenueCampaignEmail from "./Components/VenueCampaignEmail.vue";
import VenueCampaignSms from "./Components/VenueCampaignSms.vue";
import EmailTemplateEditor from "@/components/EmailTemplateEditor/EmailTemplateEditor.vue";

export default {
  components: {
    EmailTemplateEditor,
    VenueCampaignGeneral,
    VenueCampaignEmail,
    VenueCampaignSms,
  },
  data() {
    return {
      isLoading: true,
    };
  },
  async mounted() {},
  methods: {
    // clickRoute(routeName) {
    //   this.$router.replace({ name: "lists", params: { listname: routeName } });
    // },
    async onClickSave() {
      console.log("Clicked save", this.venueCampaign);

      //Call service
      try {
        this.$vs.loading();
        await this.$store.dispatch("venueCampaigns/update", this.venueCampaign);
        this.$vs.notify({
          color: "green",
          title: "Campaign updated",
          text: "The campaign was successfully updated",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign could not update",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    onReset() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to reset this Campaign? The email and sms content will be removed and reset to the original template from the Master Campaign.",
        accept: async () => {
          try {
            this.$vs.loading();
            await this.$store.dispatch("venueCampaigns/resetFromMaster", this.venueCampaign.id);
            this.$vs.notify({
              color: "green",
              title: "Campaign reset",
              text: "The campaign was successfully reset",
            });
          } catch (err) {
            console.error(err);

            this.$vs.notify({
              color: "danger",
              title: "Campaign reset error",
              text: err,
            });
          } finally {
            this.$vs.loading.close();
          }
        },
      });
    },

    // When submitting for approval
    async onSubmit() {
      try {
        this.$vs.loading();
        await this.$store.dispatch("venueCampaigns/submitForApproval", this.venueCampaign.id);
        this.$vs.notify({
          color: "green",
          title: "Campaign submitted",
          text: "The campaign was successfully submitted for approval",
        });
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Campaign submit error",
          text: err,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  computed: {
    ...mapGetters({
      venueCampaign: "venueCampaigns/venueCampaign",
      activeVenue: "venues/activeVenue",
    }),
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    isEditable() {
      return this.venueCampaign.status == "ReadyToFillOut" || this.venueCampaign.status == "Rejected";
    },
  },
  created() {
    var venueCampaignId = this.$route.params.id;

    this.isLoading = true;
    this.$store.dispatch("venueCampaigns/get", venueCampaignId);
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
